export default {
  init() {
    // JavaScript to be fired on all pages

    $('.block-link').click(function() {
      var thisdata = $(this).attr('data-href');
      window.location.href = thisdata;
    });

    $('.hamburger').click(function() {
      $(this).toggleClass('is-active');
    });

    function headerSize() {
      setTimeout (function () {
        var headerOuterHeight = $('#nav-header').outerHeight(true);
        $('.wrap').css('margin-top', headerOuterHeight);
      }, 300);
    }

    $(document).ready(function() {
      headerSize();
      $(window).resize(function() {
        headerSize();
      });
    });

   // Define our viewportWidth variable
   var viewportWidth;

   // Set/update the viewportWidth value
   var setViewportWidth = function () {
     viewportWidth = window.innerWidth || document.documentElement.clientWidth;
   }

   // Move elements for mobile use
   var moveNav = function () {
     if (viewportWidth < 1000) {
       $('#menu-top-navigatie').appendTo('#primary-nav');
       $('form[role="search"]').appendTo('#primary-nav');
     } else {
       $('#menu-top-navigatie').appendTo('#top-bar');
       $('#header-search').appendTo('#main-nav-container');
     }
   }

  $('li.gform_validation_container input').attr('tabindex', '-1');

   // Set our initial width and log it
   setViewportWidth();
   moveNav();

   // On resize events, recalculate and log
   if (viewportWidth > 800) {
      window.addEventListener('resize', function () {
        setViewportWidth();
        moveNav();
      }, false);
    }

    $('.block-link').click(function() {
      var thisdata = $(this).attr('data-href');
      if (thisdata) {
        window.location.href = thisdata;
      }
    });


    const form = document.querySelector('.gform_wrapper');
    if (form.classList.contains('gform_wrapper')) {
      document.querySelector('.name .ginput_container input[type="text"]').setAttribute('autocomplete', 'name');
    }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js